import script from "./VolunteerInvitation.vue?vue&type=script&setup=true&lang=js"
export * from "./VolunteerInvitation.vue?vue&type=script&setup=true&lang=js"

import "./VolunteerInvitation.vue?vue&type=style&index=0&id=e3f08524&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3f08524"]])

export default __exports__